import React from "react";
import axios from "axios";

import Loading from "../general/Loading.js";
import Search from "../general/Search.js";
import GeneralTd from "../table-componets/GeneralTd.js";

class EmployeeSearch extends React.Component {
  state = {
    searchText: "",
    employees: [],
    loading: false
  };

  buildData() {
    var that = this;

    this.setState({ loading: true });

    axios({
      method: "get",
      url:
        "/search_employees.json?search=" +
        this.state.searchText +
        "&method=full_name&include=account&limit=10",
      responseType: "json"
    }).then(function(response) {
      that.setState({ employees: response.data, loading: false });
    });
  }

  newSearch(newSearch) {
    this.setState({ searchText: newSearch });
    this.buildData();
  }

  toggleArchiveEmployee(employeeId, index) {
    var that = this;

    this.setState({ loading: true });

    axios({
      method: "post",
      url: "/toggle_archive_employee",
      data: {
        id: employeeId
      },
      responseType: "json"
    })
      .then(function(response) {
        if (response.data.archived == true) {
          toastr.error("Employee Archived");
        } else {
          toastr.success("Employee Unarchived");
        }

        var employees = that.state.employees;
        employees[index].email = response.data.email;
        employees[index].archived = response.data.archived;
        that.setState({ employees: employees });
      })
      .catch(function(error) {
        toastr.error("Error: Please try again");
        console.log(error);
      });
  }

  setAccount(accountId) {
    var that = this;

    axios
      .post("/change_account/", { account_id: accountId })
      .then(function(response) {
        toastr.success("Account changed");
        setTimeout(
          function() {
            window.location.href = "/users";
          }.bind(this),
          300
        );
      })
      .catch(function(error) {
        toastr.error("Account not changed");
        console.log(error);
      });
  }

  renderBody() {
    var that = this;
    var employees = [];

    _.forEach(this.state.employees, function(employee, index) {
      employees.push(
        <tr key={index}>
          <GeneralTd fieldValue={employee.first_name} />
          <GeneralTd fieldValue={employee.last_name} />
          <GeneralTd fieldValue={employee.email} />
          <GeneralTd fieldValue={employee.account_id}
          />
          <GeneralTd
            fieldValue={
              employee.account ? employee.account.name : employee.account_id
            }
          />
          <GeneralTd fieldValue={employee.active ? "Y" : "N"} />
          <GeneralTd fieldValue={employee.archived ? "Y" : "N"} />
          <td>
            <a
              className="btn btn-long btn-text pull-right"
              onClick={function() {
                that.toggleArchiveEmployee(employee.id, index);
              }}
            >
              {employee.archived ? "UNARCHIVE" : "ARCHIVE"}
            </a>
          </td>
          <td>
            <a
              className="btn btn-text pull-right"
              onClick={function() {
                that.setAccount(employee.account.id);
              }}
            >
              GOTO ACCOUNT
            </a>
          </td>
        </tr>
      );
    });

    return <tbody>{employees}</tbody>;
  }

  render() {
    var that = this;

    return (
      <div>
        <h1>Employee Search</h1>
        <br />
        <div className="row">
          <Search
            newSearchCallback={newSearch => this.newSearch(newSearch)}
            fieldClassName="col-md-12"
            placeholder="Search for an employee on any DigiQuatics account. Results limited to 10 employees."
          />
        </div>
        <br />
        {that.state.employees.length ? (
          <div>
            <table className="table table-clean table-white">
              <thead>
                <tr>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Account ID</th>
                  <th>Account</th>
                  <th>Active</th>
                  <th>Archived</th>
                  <th />
                  <th />
                </tr>
              </thead>
              {this.renderBody()}
            </table>
          </div>
        ) : (
          <Loading
            loading={this.state.loading}
            noDataMessage="No employees found, please search for an employee"
          />
        )}
      </div>
    );
  }
}

export default EmployeeSearch;
